import React from 'react';

const Reserva = ({ onClick }) => {
  return (
    <a
      className="btn-accion"
      href="https://2626ba419c4acd951d700e987eb7403a951951b3.agenda.softwaredentalink.com/agenda?modalidad=1"
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      RESERVA TU HORA
    </a>
  );
};

export default Reserva; 